const Colors = {
  primary: "#21ce86",
  secondary: "#4e7884",
  ternary: "#185563",
  quaternary: "#029989",
  white: "#ffffff",
};

export { Colors };
